"use client";

import { useSearchParams } from "next/navigation";
import { Suspense } from "react";

type Props = {
  paramName: string;
  param: string | null;
  children: React.ReactNode;
};

function HideChild(props: Props) {
  const { paramName, param, children } = props;
  const searchParams = useSearchParams();
  const paramVal = searchParams.get(paramName);

  return param === paramVal || <>{children}</>;
}

export function HideChildOnSearchParam(props: Props) {
  return (
    <Suspense fallback={props.children}>
      <HideChild {...props} />
    </Suspense>
  );
}
